export const Footer = () => {

    return (

        <footer className="AltoFooter footer footer-center  w-full p-4  text-white font-bold bg-blue-950 text-sm md:text-normal lg:text-lg">
            <div className="flex justify-center" >
                <img className="h-20 w-56" src="/assets/images/logoBlanco.png" alt="logo" />
            </div>
            <div className="flex justify-center">
                <h5 className="text-xs mt-2 text-center">© 2023 | Cooperativa de Ahorro y Crédito Integral, Cobán R. L.</h5>
            </div>
        </footer>
    );
};
